// extracted by mini-css-extract-plugin
export default {"homeSideBarScrollbar":"HomeSideBar_homeSideBarScrollbar__v0BBh"};